import { useModalStore,  } from "store";
import React, { useState } from "react";
import styled from "styled-components";
import { FlexContainer } from "./FlexContainer";
import { AppButton } from "site/ui";
import { Text } from "./Text";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  // width: 400px;
  text-align: center;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

const Image = styled.img`
  width: 74px;
  height: 74px;
  gap: 0px;
`;

const GeneralModal: React.FC = () => {
  const { isOpen, closeModal, title, message, onConfirm, isDelete } =
    useModalStore();

  const [loading, setLoading] = useState(false)

  const Icon = isDelete ? DeleteOutlined : InfoCircleOutlined;
  return (
    <Modal
      title={null}
      open={isOpen}
      footer={null}
      onCancel={closeModal}
      // width={400}
      centered
      closable={false}
    >
      <ModalContainer>
        <Icon style={{ color: "#faad14", fontSize: "24px" }} /> 
        <Text color="#131313" fontSize="16px" style={{ textAlign: "center" }}>
          {title}
        </Text>
        <Text
          color="#828080"
          fontSize="14px"
          style={{ textAlign: "center", marginTop: 20 }}
        >
          {message}
        </Text>
        <FlexContainer
          justifyContent="space-between"
          style={{ marginTop: "20px" }}
        >
          <AppButton onClick={closeModal} variant="accent">
            No
          </AppButton>
          <AppButton
            loading={loading}
            onClick={() => {
              (async() => {
                setLoading(true)
                await onConfirm();
                setLoading(false)
                closeModal();
              })()
            }}
            variant={isDelete ? "delete" : "primary"}
          >
            Yes {isDelete && "Delete"}
          </AppButton>
        </FlexContainer>
      </ModalContainer>
    </Modal>
  );
};

export default GeneralModal;
